export default __webpack_public_path__ + "static/media/save.5caaf4ba.svg";